import processProxy from '@/env/processProxy';
import { originFromBaseUrl, resolveChildBaseUrl } from '@/utils/childBaseUrl';

const DEFAULT_LENDI_AI_BASE_URL = 'http://localhost:8200';

export type ResolveLendiAiBaseUrlOptions = {
  forceDev?: boolean;
  customBaseUrl?: string;
};

export function resolveLendiAiBaseUrl(
  options?: ResolveLendiAiBaseUrlOptions,
): string {
  return resolveChildBaseUrl({
    envBaseUrl: processProxy.VUE_APP_LENDI_AI_URL ?? '',
    devUrl: DEFAULT_LENDI_AI_BASE_URL,
    testingUrl: undefined,
    fallback: DEFAULT_LENDI_AI_BASE_URL,
    forceDev: options?.forceDev,
    customBaseUrl: options?.customBaseUrl,
  });
}

export function lendiAiOriginFromBaseUrl(baseUrl: string): string {
  return originFromBaseUrl(baseUrl, 'lendiAi');
}
